<small class="unit">
    ( <ng-content></ng-content> )
</small>
